import { useStyletron } from 'baseui';

type Props = {
  clicked: () => void;
};

const DrawerToggle = ({ clicked }: Props) => {
  const [css] = useStyletron();

  const childStyles = css({
    width: '90%',
    height: '4px',
    borderRadius: '4px',
    backgroundColor: 'black',
  });
  const parentStyles = css({
    width: '30px',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '10px 0',
    boxSizing: 'border-box',
    cursor: 'pointer',
  });
  return (
    <div className={parentStyles} onClick={clicked}>
      <div className={childStyles}></div>
      <div className={childStyles}></div>
      <div className={childStyles}></div>
    </div>
  );
};
export default DrawerToggle;
